import PassengersTableViewer from './PassengersTableViewer';

export default PassengersTableViewer;
